export const ESTADO_STOCK = Object.freeze({
    RESERVADO: 'Reservado',
    PENDIENTE: 'Sujeto a definición',
    ACTIVO: 'Activo',
    RESERVADO_SV: 'Reservado SV',
    FACTURADO: 'Facturado',
    NO_A_LA_VENTA: 'No a la venta',
    PRONTO_EN_STOCK: 'Pronto en stock',
  })

  export const ESTADO_STOCK_DISPONIBLE =  Object.freeze({
    FISICO: 'FISICO',
    A_DEUDA: 'A DEUDA',
  })

  export const FILE_TYPES =  Object.freeze({
    PDF_EXTENSION: 'pdf',
    PDF: 'application/pdf',
    DOC: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    DOCX: 'application/msword',
    XLS: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    XLSX: 'application/vnd.ms-excel',
    PPT: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    PPTX: 'application/vnd.ms-powerpoint'
  })
  export const SALE_TYPE = Object.freeze({
    CONVENTIONAL: 'CONVENCIONAL',
    DIRECT: 'DIRECTA',
    USED: 'USADOS',
  })

  export const SALE_STATE = Object.freeze({
    GENERADO: 'GENERADO',
    LIQUIDADO: 'LIQUIDADO',
    ANULADO: 'ANULADO',
    FACTURADO: 'FACTURADO',
  })

  export const BUSINESS_UNIT = Object.freeze ({
    '0KM': '0km',
    USADOS: 'Usados',
  })

  export const OPERATION_TYPE = Object.freeze ({
    PRESUPUESTO : 'P',
    SOLICITUD_VENTA : 'S',
    PAGO_ABIERTO : 'PA'
  })

  export const CONCEPT = Object.freeze ({
    SENIA_VN :'Seña VN',
    SENIA_VO :'Seña VO',
  })

  export const ESTADO_CATALOGO = Object.freeze({
    PUBLICADO: 'Publicado',
    NO_PUBLICADO: 'No Publicado' 
  })

  export const DATEPICKER_TRANSLATE = Object.freeze({
    DAYS: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    SHORT_DAYS: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
    SHORT_MONTHS: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    MONTHS: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
  })

export const PERMISSIONS_MODULES_ACRONYMS = Object.freeze({
  Catalogo: {
    acronym: "CAT",
    function: {
      AccesoAPresupuestarDetalle:{
        acronym: 'CAT_DAP'
      },
      DetallePlanAhorroAccesoPresupuestar: {
        acronym: 'CAT_DPAP'
      },
      PlanAhorroVisualizacion: {
        acronym: 'CAT_PAV'
      }
    }
  },
  Comparador: {
    acronym: "CMP",
    function: {
      AccesoAPresupuestar:{
        acronym: 'CMP_AP'
      }
    }
  },
  Cotizador: {
    acronym: "CTZ",
    function: {
      DescargarReporte:{
        acronym: 'CTZ_DRC'
      },
      fullQuoteView: {
        acronym: 'CTZ_SFD'
      }
    }
  },
  Peritador: {
    acronym: "PER",
    function: {
      DescargarReporte:{
        acronym: 'PER_DRP'
      },
      OperarConDestinoCarmuv:{
        acronym: 'PER_OCDC'
      },
      VisualizarTodosLosPeritajes:{
        acronym: 'PER_VTLP'
      },
      EditarTasaciónFinal:{
        acronym: 'PER_ETF'
      },
    }
  },
  Producto: {
    acronym: "PRD",
    function: {
      CargadDirectaUsados:{
        acronym: 'PRD_CDU'
      },
      ConsultarValoresHistoricos:{
        acronym: 'PRD_CVH'
      },
      VisualziarPanelLateralDetalleItem:{
        acronym: 'PRD_VPLDI'
      },
      ProductManagement: {
        acronym: 'PRD_GPRD'
      }
    }
  },
  Presupuestador: {
    acronym: "PPT",
    function:{
      CargaManualBonificaciones:{
        acronym: 'PPT_CMDB'
      },
      AccionesSegunPerfil: {
        acronym: 'PPT_PAASP'
      },
      DescargarReporte: {
        acronym: 'PPT_PADR'
      },
      AutorizarBonificaciones: {
        acronym: 'PPT_GSV'
      },
      EditarGastosGestoria: {
        acronym: 'PPT_EGG'
      },
      EditarPrecioAuto: {
        acronym: 'PPT_ECP'
      },
    }
  },
  LineasFinancieras:{
    acronym:"SFN",
    function:{
      AdministracionLineasFinancieras:{
        acronym: 'SFN_ALF'
      }
    }
  },
  SolicitudDeVenta: {
    acronym:"SV",
    function:{
      EditarGastosDeEntrega:{
        acronym: 'SV_EDE'
      }
    }
  }
})

export const ESTADO_PEA = Object.freeze({
  PEA: 'Si',
  NO_PEA: 'No' 
})

export const STATE_UPLOAD_FILE = {
  error: 'error',
  normal: 'normal',
  success: 'success'
}

export const MAX_FILE_UPLOAD_SIZE = 5242880

export const COLUMN_FIELDS_SEPARATOR = ','

export const TIMEZONE = -(new Date().getTimezoneOffset() / 60)

export const USER_TIMEZONE = 'GMT' + TIMEZONE

export const BUDGET = {
  createURL: 'crear',
  createLabel: 'Presupuestar',
  simulateURL: 'simular',
  simulateLabel: 'Simular presupuesto',
}

// días que faltan para mostrar alerta de actualizar cuanta meli antes del vencimiento el token
export const MELI_DAYS_UNTIL_REFRESH_TOKEN = 15

export const ESTADO_STOCK_DROPDOWN = [
  { value: 'Activo', label: 'Activo', id: ['Activo'] },
  { value: 'Pronto en stock', label: 'Pronto en stock', id: ['Pronto en stock'] },
  { value: 'Sujeto a definición', label: 'Sujeto a definición', id: ['Sujeto a definición'] },
  { value: 'Reservado', label: 'Reservado', id: ['Reservado'] },
  { value: 'Reservado SV', label: 'Reservado SV', id: ['Reservado SV'] },
  { value: 'No a la venta', label: 'No a la venta', id: ['No a la venta'] },
  { value: 'Facturado', label: 'Facturado', id: ['Facturado'] },
]

export const CATEGORIES_VEHICLE = {
    car: 'Autos',
    motorbike: 'Motos',
}

export const DATE_OPTION_MAP = {
  'Hoy': 'hoy',
  'Ayer': 'ayer',
  'Últimos 7 días': '7dias',
  'Últimos 30 días': '30dias',
  'Mes actual': 'este-mes',
  'Mes pasado': 'mes-pasado',
}

export const ERROR_MESSAGES_TEXT = {
  forceUpdate: 'Force update required'
}